module.exports = __webpack_public_path__ + "img/3.70ba25b6.jpg";